import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@benefitsui/app/services/auth/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class HttpErrorService {
  private preventErrorRedirect = false;
  private preventLoginRedirect = false;
  constructor(
    private router: Router,
    private auth: AuthenticationService
  ) {}

  /**
   * Prevent automatic redirection to the error page on the next immediate AJAX call.
   * Normal error redirection is restored after the next call, whether an error is thrown or not.
   */
  preventNextErrorRedirect() {
    this.preventErrorRedirect = true;
  }

  /**
   * Prevent automatic redirection to the login page on the next immediate AJAX call.
   * Normal login redirection is restored after the next call, whether an error is thrown or not.
   */
  preventNextLoginRedirect() {
    this.preventLoginRedirect = false;
  }

  getPreventedRedirects() {
    const loginRedirectPrevented = this.preventLoginRedirect;
    this.preventLoginRedirect = false;
    const errorRedirectPrevented = this.preventErrorRedirect;
    this.preventErrorRedirect = false;
    return { loginRedirectPrevented, errorRedirectPrevented };
  }

  navigateToError(): void {
    this.router.navigate(['error'], { queryParamsHandling: 'preserve' });
  }

  navigateToSearch(): void {
    this.router.navigate(['search'], { queryParamsHandling: 'preserve' });
  }

  navigateToLogin(): void {
    const currentUrl = `${window.location.pathname}${window.location.search}`;
    let state;
    if (!currentUrl.startsWith('/login')) {
      state = this.auth.createState(currentUrl);
    }

    this.auth.redirectToLogin(state);
  }

  async navigateToNoAccess(): Promise<void> {
    await this.router.navigate(['no-access'], { queryParamsHandling: 'preserve' });
  }
}
